export const theme = {
  "zIndex": {
    "hide": -1,
    "auto": "auto",
    "dropdown": 1000,
    "tooltip": 1100,
    "loadingOverlay": 1200,
    "dropdownInPortal": 1300,
    "modal": 1300,
    "popover": 1300,
    "toast": 1400
  },
  "font": {
    "family": {
      "default": "Graphik, Arial, Helvetica, sans-serif",
      "graphik": "Graphik, Arial, Helvetica, sans-serif",
      "inter": "Inter, system-ui, sans-serif",
      "heading": "'Factor A', system-ui, sans-serif",
      "mono": "ui-monospace, 'Cascadia Code', 'Source Code Pro', Menlo, Consolas, 'DejaVu Sans Mono', monospace"
    },
    "weight": {
      "regular": "400",
      "strong": "500"
    },
    "size": {
      "heading1": "32px",
      "heading2": "30px",
      "heading3": "24px",
      "heading4": "21px",
      "default": "15px",
      "small": "14px",
      "caption": "13px",
      "tiny": "11px"
    },
    "line-height": {
      "heading1": "44.8px",
      "heading2": "42px",
      "heading3": "34px",
      "heading4": "29px",
      "default": "21px",
      "small": "20px",
      "caption": "18px"
    },
    "decoration": {
      "underline": "underline"
    }
  },
  "motion": {
    "standard": "cubic-bezier(0.5, 0, 0.1, 1)",
    "in": "cubic-bezier(0.25, 0, 1, 1)",
    "out": "cubic-bezier(0, 0, 0.25, 1)",
    "bounce": "cubic-bezier(0.47, 1.64, 0.41, 0.8)",
    "speed": {
      "1": "180ms",
      "2": "260ms",
      "3": "340ms",
      "4": "680ms",
      "5": "860ms"
    }
  },
  "radius": {
    "s": "2px",
    "m": "4px",
    "l": "8px",
    "xl": "12px",
    "rounded": "9999px",
    "input": "4px",
    "notification": "4px",
    "button": {
      "default": "4px",
      "small": "4px"
    },
    "iconbutton": "4px",
    "card": "4px",
    "tooltip": "4px",
    "tag": "9999px",
    "status": "9999px",
    "modal": "4px",
    "dropdown": "4px"
  },
  "size": {
    "height": {
      "input": {
        "default": "35px",
        "small": "30px"
      },
      "button": {
        "large": "45px",
        "default": "35px",
        "small": "30px",
        "extra-small": "20px"
      },
      "iconbutton": {
        "large": "45px",
        "default": "32px",
        "small": "24px",
        "extra-small": "20px"
      }
    },
    "border": {
      "button": {
        "default": "1px"
      }
    }
  },
  "spacing": [
    "0",
    "4px",
    "8px",
    "12px",
    "16px",
    "20px",
    "24px",
    "32px",
    "40px",
    "48px",
    "56px",
    "64px",
    "72px",
    "80px",
    "96px"
  ],
  "transition": {
    "default": "0.2s"
  },
  "typography": {
    "heading": {
      "1": {
        "fontFamily": "Graphik, Arial, Helvetica, sans-serif",
        "fontWeight": "500",
        "fontSize": "32px",
        "lineHeight": "44.8px"
      },
      "2": {
        "fontFamily": "Graphik, Arial, Helvetica, sans-serif",
        "fontWeight": "400",
        "fontSize": "30px",
        "lineHeight": "42px"
      },
      "3": {
        "fontFamily": "Graphik, Arial, Helvetica, sans-serif",
        "fontWeight": "500",
        "fontSize": "24px",
        "lineHeight": "34px"
      },
      "4": {
        "fontFamily": "Graphik, Arial, Helvetica, sans-serif",
        "fontWeight": "500",
        "fontSize": "21px",
        "lineHeight": "29px"
      }
    },
    "body": {
      "base": {
        "default": {
          "fontFamily": "Graphik, Arial, Helvetica, sans-serif",
          "fontWeight": "400",
          "fontSize": "15px",
          "lineHeight": "21px"
        },
        "strong": {
          "fontFamily": "Graphik, Arial, Helvetica, sans-serif",
          "fontWeight": "500",
          "fontSize": "15px",
          "lineHeight": "21px"
        }
      },
      "small": {
        "default": {
          "fontFamily": "Graphik, Arial, Helvetica, sans-serif",
          "fontWeight": "400",
          "fontSize": "14px",
          "lineHeight": "20px"
        },
        "strong": {
          "fontFamily": "Graphik, Arial, Helvetica, sans-serif",
          "fontWeight": "500",
          "fontSize": "14px",
          "lineHeight": "20px"
        }
      },
      "caption": {
        "default": {
          "fontFamily": "Graphik, Arial, Helvetica, sans-serif",
          "fontWeight": "400",
          "fontSize": "13px",
          "lineHeight": "18px"
        },
        "strong": {
          "fontFamily": "Graphik, Arial, Helvetica, sans-serif",
          "fontWeight": "500",
          "fontSize": "13px",
          "lineHeight": "18px"
        }
      },
      "tiny": {
        "default": {
          "fontFamily": "Graphik, Arial, Helvetica, sans-serif",
          "fontWeight": "400",
          "fontSize": "11px",
          "lineHeight": "15px"
        },
        "strong": {
          "fontFamily": "Graphik, Arial, Helvetica, sans-serif",
          "fontWeight": "500",
          "fontSize": "11px",
          "lineHeight": "15px"
        }
      },
      "link": {
        "default": {
          "fontFamily": "Graphik, Arial, Helvetica, sans-serif",
          "fontWeight": "400",
          "fontSize": "15px",
          "lineHeight": "21px",
          "textDecoration": "underline"
        },
        "small": {
          "fontFamily": "Graphik, Arial, Helvetica, sans-serif",
          "fontWeight": "400",
          "fontSize": "14px",
          "lineHeight": "20px",
          "textDecoration": "underline"
        },
        "caption": {
          "fontFamily": "Graphik, Arial, Helvetica, sans-serif",
          "fontWeight": "400",
          "fontSize": "13px",
          "lineHeight": "18px",
          "textDecoration": "underline"
        }
      },
      "action": {
        "base": {
          "fontFamily": "Graphik, Arial, Helvetica, sans-serif",
          "fontWeight": "400",
          "fontSize": "14px",
          "lineHeight": "16px"
        },
        "small": {
          "fontFamily": "Graphik, Arial, Helvetica, sans-serif",
          "fontWeight": "400",
          "fontSize": "12px",
          "lineHeight": "14px"
        }
      }
    }
  },
  "color": {
    "text": {
      "default": "hsl(0 0% 15% / 0.96)",
      "inverse": "hsl(0 0% 98% / 0.92)",
      "light": {
        "default": "hsl(0 0% 15% / 0.72)",
        "inverse": "hsl(0 0% 98% / 0.64)"
      },
      "disabled": "hsl(0 0% 15% / 0.52)",
      "link": {
        "default": "#5489DC",
        "hover": "#4A78C1"
      },
      "active": "#5489DC",
      "danger": "#88232E",
      "success": "#1E682E",
      "info": "hsl(0 0% 15% / 0.96)",
      "warning": "#BF9023",
      "ai": "#8558DF",
      "input": {
        "placeholder": "hsl(0 0% 15% / 0.52)"
      },
      "action": {
        "primary": "hsl(0 0% 98% / 0.92)",
        "danger": "hsl(0 0% 98% / 0.92)",
        "alt": {
          "primary": "#3F67A5",
          "danger": "#BF3140"
        }
      },
      "button": {
        "accent": {
          "primary": {
            "default": "hsl(0 0% 98% / 0.92)",
            "hover": "hsl(0 0% 98% / 0.92)",
            "pressed": "hsl(0 0% 98% / 0.92)",
            "disabled": "hsl(0 0% 15% / 0.52)"
          },
          "secondary": {
            "default": "#5489DC",
            "hover": "#5489DC",
            "pressed": "#5489DC",
            "disabled": "hsl(0 0% 15% / 0.52)"
          },
          "tertiary": {
            "default": "#5489DC",
            "hover": "hsl(0 0% 15% / 0.96)",
            "pressed": "hsl(0 0% 15% / 0.96)",
            "disabled": "hsl(0 0% 15% / 0.52)"
          }
        },
        "danger": {
          "primary": {
            "default": "hsl(0 0% 98% / 0.92)",
            "hover": "hsl(0 0% 98% / 0.92)",
            "pressed": "hsl(0 0% 98% / 0.92)",
            "disabled": "hsl(0 0% 15% / 0.52)"
          },
          "secondary": {
            "default": "#BF3140",
            "hover": "#BF3140",
            "pressed": "#BF3140",
            "disabled": "hsl(0 0% 15% / 0.52)"
          },
          "tertiary": {
            "default": "#BF3140",
            "hover": "#BF3140",
            "pressed": "#BF3140",
            "disabled": "hsl(0 0% 15% / 0.52)"
          }
        }
      }
    },
    "border": {
      "default": "#CFCFCF",
      "light": "#DDDDDD",
      "disabled": "#EEEEEE",
      "active": "#5489DC",
      "danger": "#E36A77",
      "success": "#94C8A0",
      "info": "#EEEEEE",
      "warning": "#FED77C",
      "ai": "#DACCF5",
      "input": {
        "default": "#DDDDDD",
        "hover": "#CFCFCF",
        "readonly": "#FFFFFF"
      },
      "button": {
        "accent": {
          "primary": {
            "default": "transparent",
            "hover": "transparent",
            "pressed": "transparent",
            "disabled": "transparent"
          },
          "secondary": {
            "default": "#5489DC",
            "hover": "#5489DC",
            "pressed": "#5489DC",
            "disabled": "transparent"
          },
          "tertiary": {
            "default": "transparent",
            "hover": "transparent",
            "pressed": "transparent",
            "disabled": "transparent"
          }
        },
        "danger": {
          "primary": {
            "default": "transparent",
            "hover": "transparent",
            "pressed": "transparent",
            "disabled": "transparent"
          },
          "secondary": {
            "default": "#E36A77",
            "hover": "#E36A77",
            "pressed": "#E36A77",
            "disabled": "#E36A77"
          },
          "tertiary": {
            "default": "transparent",
            "hover": "transparent",
            "pressed": "transparent",
            "disabled": "transparent"
          }
        }
      }
    },
    "background": {
      "transparent": "transparent",
      "surface": {
        "default": "#FFFFFF",
        "inverse": "#000000",
        "middle": "#F9F9F9",
        "fore": "#EEEEEE"
      },
      "default": "#F9F9F9",
      "disabled": "#CFCFCF",
      "active": "#D4E2F6",
      "danger": "#FAE6E8",
      "success": "#E5F4E8",
      "info": "#EAF0FB",
      "warning": "#FFF7E5",
      "ai": "#ECE5FA",
      "mask": "hsl(0 0% 15% / 0.5)",
      "input": {
        "default": "#FFFFFF",
        "readonly": "#FFFFFF"
      },
      "toggle": {
        "default": "#CFCFCF",
        "active": "#247D38"
      },
      "switch": {
        "default": "#EEEEEE",
        "active": "#30A64A",
        "disabled": "#CFCFCF",
        "error": "#FAE6E8",
        "marker": {
          "default": "#DDDDDD",
          "active": "#247D38",
          "error": "#F1B4BB"
        },
        "control": {
          "default": "#FFFFFF",
          "disabled": "#EEEEEE"
        }
      },
      "progress": {
        "default": "#DDDDDD",
        "active": {
          "default": "#3F67A5",
          "light": "#AAC4ED"
        }
      },
      "action": {
        "primary": {
          "default": "#5489DC",
          "hover": "#3F67A5",
          "pressed": "#355689"
        },
        "secondary": {
          "default": "#FFFFFF",
          "hover": "#D4E2F6",
          "pressed": "#BFD3F2"
        },
        "tertiary": {
          "default": "#FFFFFF",
          "hover": "#EEEEEE",
          "pressed": "#DDDDDD"
        },
        "danger": {
          "default": "#DA3849",
          "hover": "#BF3140",
          "pressed": "#A42A37",
          "light": {
            "default": "#DA3849",
            "hover": "#BF3140",
            "pressed": "#A42A37"
          }
        }
      },
      "button": {
        "accent": {
          "primary": {
            "default": "#5489DC",
            "hover": "#3F67A5",
            "pressed": "#355689",
            "disabled": "#CFCFCF"
          },
          "secondary": {
            "default": "transparent",
            "hover": "#D4E2F6",
            "pressed": "#BFD3F2",
            "disabled": "#CFCFCF"
          },
          "tertiary": {
            "default": "transparent",
            "hover": "#EEEEEE",
            "pressed": "#DDDDDD",
            "disabled": "#CFCFCF"
          }
        },
        "danger": {
          "primary": {
            "default": "#DA3849",
            "hover": "#BF3140",
            "pressed": "#A42A37",
            "disabled": "#CFCFCF"
          },
          "secondary": {
            "default": "transparent",
            "hover": "transparent",
            "pressed": "transparent",
            "disabled": "#CFCFCF"
          },
          "tertiary": {
            "default": "transparent",
            "hover": "transparent",
            "pressed": "transparent",
            "disabled": "#CFCFCF"
          }
        }
      }
    },
    "status": {
      "background": {
        "translating": "#FFFFFF",
        "review": "#FFFFFF",
        "completed": "#FFFFFF",
        "error": "#FFFFFF"
      },
      "text": {
        "translating": "#FFFFFF",
        "review": "#FFFFFF",
        "completed": "#FFFFFF",
        "error": "#FFFFFF"
      }
    }
  },
  "elevation": {
    "layer1": "0px 0px 2px rgba(38, 38, 38, 0.1), 0px 4px 6px rgba(38, 38, 38, 0.04), 0px 8px 16px rgba(38, 38, 38, 0.04), 0px 10px 20px 2px rgba(38, 38, 38, 0.02)",
    "layer2": "0px 1px 4px rgba(38, 38, 38, 0.1), 0px 4px 6px rgba(38, 38, 38, 0.04), 0px 8px 16px rgba(38, 38, 38, 0.04), 0px 10px 20px 2px rgba(38, 38, 38, 0.02), 0px 12px 24px 4px rgba(38, 38, 38, 0.04)",
    "layer3": "0px 2px 8px rgba(38, 38, 38, 0.1), 0px 4px 6px rgba(38, 38, 38, 0.04), 0px 8px 16px rgba(38, 38, 38, 0.04), 0px 12px 24px 2px rgba(38, 38, 38, 0.04), 0px 20px 48px 8px rgba(38, 38, 38, 0.1)",
    "focus": "0px 0px 0px 2px #FFFFFF, 0px 0px 0px 4px #5489DC, 0px 0px 2px 4px #4A78C1"
  },
  "mode": "light"
};
